import { convertToKebabCase } from '../../../../../../../../constants/helpers/text';

export const detectIsLabelSelected = (label: string, selectedSubpage: string): boolean =>
  convertToKebabCase(label) === convertToKebabCase(selectedSubpage);
